import { render, staticRenderFns } from "./spliteBill.vue?vue&type=template&id=0c075cc6&scoped=true&"
import script from "./spliteBill.vue?vue&type=script&lang=js&"
export * from "./spliteBill.vue?vue&type=script&lang=js&"
import style0 from "./spliteBill.vue?vue&type=style&index=0&id=0c075cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c075cc6",
  null
  
)

export default component.exports